module.exports = __webpack_public_path__ + "img/total-points.e7436e36.svg";